<template>
  <div>
    <v-main>
      <div>
        <h1>ddd</h1>
      </div>
    </v-main>
  </div>
</template>

<script>
export default {
  name: 'LoyaltySystemEditv2',

  data () {
    return {

    }
  },

  mounted () {

  },

  methods: {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Master/Editv2.vue